export const pagesDevicesAlertsEn = {
  filter: {
    deviceGroupAll: 'All device groups',
    deviceGroupNoResults: 'No device groups found',
    deviceGroupSearch: 'Search device groups…',
    ruleAll: 'All assignment rules',
    ruleNoResults: 'No assignment rules found',
    ruleSearch: 'Search assignment rules…'
  },
  helpToggle: {
    toBeAssigned: {
      body: 'Members who match assignment rules but do not yet have a device from the expected device group.',
      title: 'What is To be assigned'
    },
    unknownAssignment: {
      body: 'Devices currently assigned to members for whom no assignment rule defines an expected device group.',
      title: 'What is an unknown assignment'
    }
  },
  pageTitle: 'Device alerts',
  searchPlaceholder: {
    unknownAssignment: 'Search device name…'
  },
  sidebar: {
    closeSideTab: 'Close side tab',
    openSideTab: 'Open',
    title: 'Alert categories',
    toBeAssigned: 'To be assigned',
    unknownAssignment: 'Unknown assignment'
  }
};